import { Injectable } from '@angular/core';
import { AvisInitialType } from '../../models/AvisInitialType';
import { Joce } from '../../models/Joce';

@Injectable({
  providedIn: 'root'
})
export class AvisInitialService {

  constructor() {
  }

  public getAvisInitial(controls): AvisInitialType {
    const avisInitial = new AvisInitialType();
    avisInitial.idWeb = controls.get('_SepSep_Attribution_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_idWeb');

    const datePublication = '_SepSep_Attribution_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_datePublication';
    avisInitial.datePublication =
      controls.get(datePublication) +
      controls.get(datePublication + '_timestamp');

    return avisInitial;
  }
}
